import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

/* AuthCallback processes the Emergent OAuth session_id fragment (see auth playbook).
   REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH */
export default function AuthCallback() {
  const { loginWithSessionId } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const user = await loginWithSessionId(sessionId);
        // Clear the hash and go to dashboard
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user } });
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Authentication failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [loginWithSessionId, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505]">
      <div className="text-center">
        <div className="font-mono text-[10px] uppercase tracking-widest text-[color:var(--hq-cyan)] animate-pulse">
          FINALISING SIGN-IN
        </div>
      </div>
    </div>
  );
}
